// 1. 외부 패키지


// 2. 프로젝트 내부 alias


// 3. 상대 경로
import Skeleton from "../skeleton";

// 4. 타입

const RightSkeleton = () => {
	return (
		<div className="right">
			<Skeleton width={'100%'} height={218} marginBottom={20} />
			<Skeleton width={'100%'} height={200} marginBottom={20} radius={4} />
		</div>
	);
};

export default RightSkeleton;